'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_dec2,_dec3,_dec4,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const ErrorMessages=require('../../../../../dist-es6/client/errorMessages');

const EmailErrorMessage='Please enter an email address.';
const PasswordErrorMessage='Please enter a password.';
const LoginErrorMessage=`Invalid email address and\npassword combination.`;
const ExpiredLinkErrorMessage='Password reset link is expired.';
const InvalidNewPasswordErrorMessage='Password must meet requirements.';


const TechnicalSupportEmailAddress='info@pulsarinformatics.com';
const TechnicalSupportPhoneNumber='877.791.0989';let

LoginModalController=(_dec=




















































































































































HandleUncaughtErrors(function(){return ModalSubmissionResult.KeepOpen}),_dec2=









































HandleUncaughtErrors(function(){return ModalSubmissionResult.KeepOpen}),_dec3=




















































































HandleUncaughtErrors(function(){return ModalSubmissionResult.KeepOpen}),_dec4=















HandleUncaughtErrors(function(){return ModalSubmissionResult.KeepOpen}),(_class=function(_BaseController){_inherits(LoginModalController,_BaseController);function LoginModalController($state,$modalInstance,elementService,userService,uncaughtErrorHandler,uiCommandFactory,reason,$timeout,socketService,$scope,redirectionService){_classCallCheck(this,LoginModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._$state=$state;_this._userService=userService;_this._$modalInstance=$modalInstance;_this._reason=reason;_this._rememberAfterDisconnect=!0;_this._elementService=elementService;_this._$timeout=$timeout;_this._socketService=socketService;_this._redirectionService=redirectionService;_this.determineAuthMechanismCommand=uiCommandFactory.makeForModal($modalInstance,_this._determineAuthMechanism.bind(_this));_this.loginCommand=uiCommandFactory.makeForModal($modalInstance,_this._login.bind(_this));_this.requestPasswordResetCommand=uiCommandFactory.makeForModal($modalInstance,_this._requestPasswordReset.bind(_this));_this.performPasswordResetCommand=uiCommandFactory.makeForModal($modalInstance,_this._performPasswordReset.bind(_this));_this._buildStateClasses();_this._newPasswordIsVisible=!0;_this.showingFront=!0;if(_this._onLoginPage){$scope.$watch('controller._$state.params',function(newParams,oldParams){if(_this._onLoginPage&&!_.exists(newParams.passwordResetRequest)&&_this._isValidState(newParams.state)){_this._resetErrorMessages();_this._flipTo(newParams.state)}},!0);if(_.exists(_this._$state.params.passwordResetRequest)){_this.frontState='perform-reset';_this._promisedBeginResetResponse=_this._socketService.sendAndWaitForResponse('BeginPasswordReset',{token:_this._$state.params.passwordResetRequest});_this._promisedBeginResetResponse.then(function(response){return _this._checkForPasswordResetExpiration(response)})}}_this.frontState=_this.frontState||(_this._onLoginPage&&_this._isValidState(_this._$state.params.state)?_this._$state.params.state:'login');_this._makeUrlMatchCurrentState();_this._resetErrorMessages();$timeout(function(){_this.ready=!0;$timeout(function(){_this._resetFocus()})});return _this}LoginModalController.prototype._resetFocus=function _resetFocus(){let elementId;switch(this._currentState){case'login':elementId='#login-email';break;case'request-reset':elementId='#forgot-password-email';break;case'perform-reset':elementId='#new-password';break;}if(_.exists(elementId)){this._elementService.selectElement(elementId)[0].focus()}};LoginModalController.prototype._buildStateClasses=function _buildStateClasses(){this._states=['login','request-reset','check-mail','perform-reset'];this.classes={};for(let state of this._states){this.classes[state]=`{ front: controller.frontState === '${state}', back: controller.backState === '${state}', hidden: controller.frontState !== '${state}' && controller.backState !== '${state}' }`}};LoginModalController.prototype._isValidState=function _isValidState(state){return _.includes(this._states,state)};LoginModalController.prototype._makeUrlMatchCurrentState=function _makeUrlMatchCurrentState(){if(!this._onLoginPage){return}this._$state.go('fdc.features.login',{state:this._currentState,passwordResetRequest:this._currentState==='perform-reset'?this._$state.params.passwordResetRequest:void 0,return_to:this._$state.params.return_to})};LoginModalController.prototype._checkForPasswordResetExpiration=function _checkForPasswordResetExpiration(response){var _this2=this;if(SocketResponse.isHttpError(response,404)){this._flipTo('request-reset',function(){_this2._generalErrorMessage=ExpiredLinkErrorMessage});return!1}return!0};LoginModalController.prototype._resetErrorMessages=function _resetErrorMessages(){this._emailErrorMessage=null;this._passwordErrorMessage=null;this._generalErrorMessage=null};LoginModalController.prototype._determineAuthMechanism=function(){var ref=_asyncToGenerator(function*(){var _this3=this;this._resetErrorMessages();const params={email:this._email};const result=yield this._socketService.sendAndWaitForResponse('DetermineAuthMechanism',params);if(!SocketResponse.succeeded(result)){return this._handleModalSubmissionErrorsAndGetModalResult(result,params)}const authMechanismResponse=result.body;if(!_.exists(authMechanismResponse.authenticationFrontend)||authMechanismResponse.authenticationFrontend==='redirect'&&!_.exists(authMechanismResponse.url)||authMechanismResponse.authenticationFrontend==='local'&&authMechanismResponse.email!==params.email.toLowerCase()){this._generalErrorMessage=ErrorMessages.InvalidAuthConfig;return ModalSubmissionResult.KeepOpen}this._authenticationFrontend=authMechanismResponse.authenticationFrontend;switch(authMechanismResponse.authenticationFrontend){case'redirect':this._$timeout(function(){window.location=authMechanismResponse.url},500);break;case'local':this._$timeout(function(){_this3._elementService.selectElement('form[name="loginForm"] input#password').focus()},100);break;default:this._generalErrorMessage=ErrorMessages.OopsTryAgain;throw new Error('Got unknown authenticationFrontend: '+authMechanismResponse.authenticationFrontend);}return ModalSubmissionResult.KeepOpen});function _determineAuthMechanism(){return ref.apply(this,arguments)}return _determineAuthMechanism}();LoginModalController.prototype._login=function(){var ref=_asyncToGenerator(function*(){this._resetErrorMessages();const params={email:this._email,password:this._password,rememberAfterDisconnect:this._rememberAfterDisconnect};let result=yield this._userService.beginUserSession(params);if(SocketResponse.succeeded(result)){return ModalSubmissionResult.Close()}return this._handleModalSubmissionErrorsAndGetModalResult(result,params)});function _login(){return ref.apply(this,arguments)}return _login}();LoginModalController.prototype._handleModalSubmissionErrorsAndGetModalResult=function _handleModalSubmissionErrorsAndGetModalResult(result,params){let errors=result.status==='HttpError'?_.get(result,'body.errors',[]):[];for(const error of errors){switch(error){case'instance requires property "email"':case'instance.email does not conform to the "email" format':case`invalid email address: ${params.email}`:this._emailErrorMessage=EmailErrorMessage;break;case'instance requires property "password"':case'instance.password does not meet minimum length of 1':this._passwordErrorMessage=PasswordErrorMessage;break;case'Invalid username and password combination.':this._generalErrorMessage=LoginErrorMessage;break;}}if(!_.exists(this._emailErrorMessage)&&!_.exists(this._passwordErrorMessage)&&!_.exists(this._generalErrorMessage)){this._generalErrorMessage=ErrorMessages.OopsTryAgain}return ModalSubmissionResult.KeepOpen};LoginModalController.prototype._resetAuthMechanismAndPassword=function _resetAuthMechanismAndPassword(){var _this4=this;this._$timeout(function(){_this4._authenticationFrontend=null;_this4._password=''})};LoginModalController.prototype._flipTo=function _flipTo(nextState,postFlipAction){var _this5=this;if(!this._isValidState(nextState)){throw new Error('unexpected state')}this._$timeout(function(){if(nextState===_this5._currentState){return}if(_this5.showingFront){_this5.backState=nextState}else{_this5.frontState=nextState}_this5._$timeout(function(){_this5.showingFront=!_this5.showingFront;_this5._makeUrlMatchCurrentState();_this5._resetFocus();if(_.exists(postFlipAction)){_this5._$timeout(function(){return postFlipAction()})}})})};LoginModalController.prototype._requestPasswordReset=function(){var ref=_asyncToGenerator(function*(){this._resetErrorMessages();let email=this.email;let result=yield this._socketService.sendAndWaitForResponse('RequestPasswordReset',{email:email});if(SocketResponse.isHttpError(result,422)){this._emailErrorMessage=EmailErrorMessage}else{this._flipTo('check-mail')}return ModalSubmissionResult.KeepOpen});function _requestPasswordReset(){return ref.apply(this,arguments)}return _requestPasswordReset}();LoginModalController.prototype.
_performPasswordReset=function(){var ref=_asyncToGenerator(function*(){var _this6=this;
this._resetErrorMessages();

if(_.exists(this._promisedBeginResetResponse)){
let beginResetResponse=yield this._promisedBeginResetResponse;
if(!this._checkForPasswordResetExpiration(beginResetResponse)){
return ModalSubmissionResult.KeepOpen;
}

if(!SocketResponse.succeeded(beginResetResponse)){
this._generalErrorMessage=ErrorMessages.OopsTryAgain;
return ModalSubmissionResult.KeepOpen;
}
}

let finishResetResponse=yield this._socketService.sendAndWaitForResponse('FinishPasswordReset',{
token:this._$state.params.passwordResetRequest,
newPassword:this.newPassword});


if(!this._checkForPasswordResetExpiration(finishResetResponse)){
return ModalSubmissionResult.KeepOpen;
}

if(SocketResponse.isHttpError(finishResetResponse,422)){
this._newPasswordErrorMessage=InvalidNewPasswordErrorMessage;
return ModalSubmissionResult.KeepOpen;
}else if(!SocketResponse.succeeded(finishResetResponse)){
this._generalErrorMessage=ErrorMessages.OopsTryAgain;
return ModalSubmissionResult.KeepOpen;
}

this._reason='PasswordChanged';
this._flipTo('login',function(){return _this6.newPassword=''});
return ModalSubmissionResult.KeepOpen;
});function _performPasswordReset(){return ref.apply(this,arguments)}return _performPasswordReset}();LoginModalController.prototype.
















































forgotPassword=function forgotPassword(){
this._password='';
this._resetErrorMessages();
this._flipTo('request-reset');
};LoginModalController.prototype.

backToSignIn=function backToSignIn(){
this._resetErrorMessages();
this._flipTo('login');
};LoginModalController.prototype.





toggleNewPasswordVisibility=function toggleNewPasswordVisibility(){
this._newPasswordIsVisible=!this._newPasswordIsVisible;
this._resetFocus();
};_createClass(LoginModalController,[{key:'_onLoginPage',get:function(){return this._$state.current.name==='fdc.features.login'}},{key:'isGoingToHelpCenter',get:function(){return this._redirectionService.helpCenterRedirectIsPending}},{key:'DefaultEmailErrorMessage',get:function(){return EmailErrorMessage}},{key:'DefaultPasswordErrorMessage',get:function(){return PasswordErrorMessage}},{key:'reason',get:function(){return this._reason}},{key:'_currentState',get:function(){return this.showingFront?this.frontState:this.backState}},{key:'email',get:function(){return this._email},set:function(email){this._email=email}},{key:'password',get:function(){return this._password},set:function(password){this._password=password}},{key:'rememberAfterDisconnect',get:function(){return this._rememberAfterDisconnect},set:function(rememberAfterDisconnect){this._rememberAfterDisconnect=rememberAfterDisconnect}},{key:'emailErrorMessage',get:function(){return this._emailErrorMessage}},{key:'passwordErrorMessage',get:function(){return this._passwordErrorMessage}},{key:'generalErrorMessage',get:function(){return this._generalErrorMessage}},{key:'newPasswordErrorMessage',get:function(){return this._newPasswordErrorMessage}},{key:'technicalSupportPhoneNumber',get:function(){return TechnicalSupportPhoneNumber}},{key:'technicalSupportEmailAddress',get:function(){return TechnicalSupportEmailAddress}},{key:'newPassowrdIsVisible',get:function(){return this._newPasswordIsVisible}}]);return LoginModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_determineAuthMechanism',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_determineAuthMechanism'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_login',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'_login'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_requestPasswordReset',[_dec3],Object.getOwnPropertyDescriptor(_class.prototype,'_requestPasswordReset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_performPasswordReset',[_dec4],Object.getOwnPropertyDescriptor(_class.prototype,'_performPasswordReset'),_class.prototype)),_class));


module.exports=LoginModalController;
//# sourceMappingURL=loginModalController.js.map
